import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black/70 text-white text-sm py-4 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left">
        <p className="font-medium">© 2026 İSKOÇSAN Kauçuk Sanayi ve Ticaret Ltd. Şti. Tüm hakları saklıdır.</p>
        <a href="mailto:info@iskocsan.com" className="text-gray-300 hover:underline">
          info@iskocsan.com
        </a>
      </div>
    </footer>
  );
};

export default Footer;
